import { definePreset, palette } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const BdsPresets = definePreset(Aura, {
  semantic: {
    primary: palette('{blue}')
  }
});

export default BdsPresets;
